import React from 'react';

import {LazyTooltip} from 'app/components/general/LazyTooltip';
import {gt} from 'app/utils/i18n';

interface Props {
  type?: 'content' | 'decision' | 'ending' | 'processprocedure' | 'automation';
}

export const OrphanStepBadge = ({type}: Props) => (
  <LazyTooltip
    tooltip={
      type === 'processprocedure'
        ? gt('This procedure cannot be reached from the starting step.')
        : gt('This step cannot be reached from the starting step.')
    }
  >
    <span className="badge badge-danger d-print-none">
      <i className="fa fa-unlink mr-1" />
      {type === 'processprocedure'
        ? gt('Inacessible Procedure')
        : gt('Inaccessible Step')}
    </span>
  </LazyTooltip>
);
